import { axiosConToken } from "../helpers/axios";
import { types } from "../types/typesGenerales";
import { types as typesCentroCosto } from "../types/typesCentroCosto";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../helpers/messageConfig";
import { routesConfiguraciones } from "../helpers/loadConstants";

export const empresasStartLoad = () => {
  return async (dispatch) => {
    try {
      const resp = await axiosConToken.get(routesConfiguraciones.empresas);
      const data = resp.data;
      dispatch(empresasLoaded(data));
    } catch (error) {
      validaMessagesErrors(error);
    }
  };
};
export const empresaStartAdd = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        routesConfiguraciones.empresas,
        data,
      );
      const { msg, empresa } = resp.data;
      dispatch(empresaAdded(empresa));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
export const empresaStartUpdate = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${routesConfiguraciones.empresas}${data.id}/`,
        data,
      );
      const { msg, empresa } = resp.data;
      dispatch(empresaUpdated(empresa));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
export const empresaStartDelete = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Eliminando...");
    try {
      const resp = await axiosConToken.delete(
        `${routesConfiguraciones.empresas}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(empresaDeleted(data));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
const empresasLoaded = (clientes) => ({
  type: types.empresaLoaded,
  payload: clientes,
});
const empresaAdded = (cliente) => ({
  type: types.empresaAdded,
  payload: cliente,
});
const empresaUpdated = (cliente) => ({
  type: types.empresaUpdated,
  payload: cliente,
});
const empresaDeleted = (cliente) => ({
  type: types.empresaDeleted,
  payload: cliente,
});
export const empresaSetActive = (cliente) => ({
  type: types.empresaSetActive,
  payload: cliente,
});
export const empresaClearActive = () => ({ type: types.empresaClearActive });

export const centroCostosStartLoad = () => {
  return async (dispatch) => {
    dispatch(centroCostoShowLoading());
    try {
      const resp = await axiosConToken.get(routesConfiguraciones.centrocostos);
      const data = resp.data;
      dispatch(centroCostosLoaded(data));
    } catch (error) {
      validaMessagesErrors(error);
    } finally {
      dispatch(centroCostoShowLoading(false));
    }
  };
};
export const centroCostoStartAdd = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        routesConfiguraciones.centrocostos,
        data,
      );
      const { msg, centrocosto } = resp.data;
      dispatch(centroCostoAdded(centrocosto));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
export const centroCostoStartUpdate = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${routesConfiguraciones.centrocostos}${data.id}/`,
        data,
      );
      const { msg, centrocosto } = resp.data;
      dispatch(centroCostoUpdated(centrocosto));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
export const centroCostoStartDelete = (data) => {
  return async (dispatch) => {
    const msgloading = messageLoading("Eliminando...");
    try {
      const resp = await axiosConToken.delete(
        `${routesConfiguraciones.centrocostos}${data.id}/`,
      );
      const { msg } = resp.data;
      dispatch(centroCostoDeleted(data));
      messageSuccessLoading(msgloading, msg);
    } catch (error) {
      validaMessagesErrors(error, msgloading);
    }
  };
};
const centroCostosLoaded = (centroscostos) => ({
  type: typesCentroCosto.centroscostosLoaded,
  payload: centroscostos,
});
const centroCostoAdded = (centrocosto) => ({
  type: typesCentroCosto.centrocostoAdded,
  payload: centrocosto,
});
const centroCostoUpdated = (centrocosto) => ({
  type: typesCentroCosto.centrocostoUpdated,
  payload: centrocosto,
});
const centroCostoDeleted = (centrocosto) => ({
  type: typesCentroCosto.centrocostoDeleted,
  payload: centrocosto,
});
export const centroCostoSetActive = (centrocosto) => ({
  type: typesCentroCosto.centrocostoSetActive,
  payload: centrocosto,
});
export const centroCostoShowLoading = (loading = true) => ({
  type: typesCentroCosto.centrocostoLoading,
  payload: loading,
});
export const centroCostoClearActive = () => ({
  type: typesCentroCosto.centrocostoClearActive,
});

export const get_soap_tipos = async () => {
  let data = null;
  try {
    const resp = await axiosConToken.get(
      `${routesConfiguraciones.empresas}get_soap_types/`,
    );
    data = resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
  return data;
};
export const get_centroscostos = async () => {
  try {
    const resp = await axiosConToken.get(routesConfiguraciones.centrocostos);
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
